import React, { useCallback } from 'react';
import { AppButton, Box, Inscription } from '@common-fe/common-fe';

import { usePayoutDefinitionDeleteModalStore } from '@/modules/ProcessingDefinition/PayoutDefinition/PayoutDefinitionDeleteModal/stores/usePayoutDefinitionDeleteModal.store';

const DangerZone: React.FC = () => {
  const handleChangeVisibility = usePayoutDefinitionDeleteModalStore((state) => state.handleChangeVisibility);
  const handleOpenModal = useCallback(() => handleChangeVisibility(true), [handleChangeVisibility]);
  return (
    <Box data-testid="danger-zone_wrapper" width={{ max: 'calc(50% - 4px)' }}>
      <Box
        background="canvas"
        border={{ color: 'border2', size: 'small' }}
        round="container1Round"
        pad="spacing24"
        align="center"
        gap="spacing24"
      >
        <Inscription size="24px" weight="bold" color="textTitle">
          Delete
        </Inscription>
        <AppButton
          testId="danger-zone_delete-button"
          color="red"
          width="100%"
          size="L"
          onClick={handleOpenModal}
        >
          Delete Payout Definition
        </AppButton>
      </Box>
    </Box>
  );
};

export default DangerZone;
